export const translationModeration_en = {
  blockVisitor: "Block visitor",
  blockVisitorTitle: "Block this visitor?",
  blockVisitorDescription:
    "They can no longer see or use the chat on any of your organization's chatbots. You can lift the block at any time under Settings, Blocked visitors.",
  blockDuration: "Block for",
  blockDays1: "1 day",
  blockDays7: "7 days",
  blockDays30: "30 days",
  blockDays90: "90 days",
  blockConfirm: "Block visitor",
  cancel: "Cancel",
  visitorBlocked: "The visitor is blocked.",
  visitorAlreadyBlocked: "This visitor is already blocked.",
  visitorNotBlockable: "Only live conversations with a known visitor can be blocked.",
  blockFailed: "The visitor could not be blocked. Try again.",
  moderationFlagged: "Moderation flagged {count} messages: {categories}.",
  moderationFlaggedOne: "Moderation flagged a message: {categories}.",
  moderationWouldBlock:
    "Moderation would have blocked this visitor, but did not block them automatically.",
  moderationBlockedUntil: "This visitor is blocked until {date}.",
  categoryRude: "Impolite",
  categoryOfftopic: "Off-topic",
  categoryNonsense: "Gibberish",
  categoryAbuse: "Abuse",
  categoryAttack: "Attack attempt",
  categorySpam: "Spam",
  badgeBlocked: "Blocked",
  badgeWouldBlock: "Would block",
  badgeFlagged: "Flagged",
  filterMisuse: "Misuse",
  filterWouldBlock: "Would block",
  pageTitle: "Blocked visitors",
  pageDescription:
    "Visitors kept out of your organization's chats, blocked by your team or by moderation. Only a fingerprint of each address is stored, never the address itself.",
  columnReason: "Reason",
  columnConversation: "Conversation",
  columnBlocked: "Blocked",
  columnExpires: "Until",
  columnActions: "Actions",
  reasonManual: "By your team",
  reasonAttack: "Attack attempt",
  reasonAbuse: "Repeated abuse",
  openConversation: "Open conversation",
  unblock: "Unblock",
  unblockTitle: "Unblock this visitor?",
  unblockDescription: "They can use the chat again right away.",
  unblocked: "The visitor is unblocked.",
  unblockFailed: "The visitor could not be unblocked. Try again.",
  noBlocks: "No visitors are blocked.",
  loadFailed: "Blocked visitors could not be loaded.",
  exemptionsTitle: "Never blocked automatically",
  exemptionsDescription:
    "Addresses moderation never blocks on its own, such as your office or a security tester you hired. Your team can still block them.",
  exemptionAddress: "IP address",
  exemptionName: "Name",
  addExemption: "Add address",
  removeExemption: "Remove",
  removeExemptionLabel: "Remove {name}",
  exemptionAdded: "The address is exempt.",
  exemptionInvalid: "Enter a valid IP address and a name.",
  exemptionExists: "That address is already exempt.",
  exemptionFailed: "The address could not be saved. Try again.",
  noExemptions: "No addresses are exempt.",
  loadingMore: "Loading more",
};
